// Helpers shared by the Spin & Win and Scratch & Win demos. Call them from
// event handlers only - they are random, so never during render.

// Index of a randomly chosen item, weighted by each item's `weight`.
export const pickWeighted = (items: { weight: number }[]) => {
  const total = items.reduce((sum, item) => sum + item.weight, 0);
  let roll = Math.random() * total;
  for (let index = 0; index < items.length; index++) {
    roll -= items[index].weight;
    if (roll < 0) return index;
  }
  return items.length - 1;
};

// A short demo redemption code, e.g. "FYD-4K2Q".
export const makeRedeemCode = () =>
  `FYD-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
